// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"37092598","788":"37092598"}[chunkId] + ".chunk.css";
};